import { render, staticRenderFns } from "./AddAssistant.vue?vue&type=template&id=5aee72ba&scoped=true&"
import script from "./AddAssistant.vue?vue&type=script&lang=js&"
export * from "./AddAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AddAssistant.vue?vue&type=style&index=0&id=5aee72ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee72ba",
  null
  
)

export default component.exports